import Api from '../Api'
import store from '@/store/store'

export default {
    // GET ALL - Récupère toutes les données du portefeuille en une seule requête
    getPortefeuille() {
        const userid = store.state.user._id
        return Api().get(`portefeuille/${userid}`)
    }
}
